import { render, staticRenderFns } from "./quickView.vue?vue&type=template&id=9caf0512&scoped=true"
import script from "./quickView.vue?vue&type=script&lang=js"
export * from "./quickView.vue?vue&type=script&lang=js"
import style0 from "./quickView.vue?vue&type=style&index=0&id=9caf0512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9caf0512",
  null
  
)

export default component.exports